import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

const EntityFormDialog = ({
  show, onClose, title, onSubmit, saving = false, children, submitLabel = "Save",
}) => (
  <Modal show={show} onHide={onClose} centered backdrop="static" className="plm-modal">
    <Modal.Header closeButton>
      <Modal.Title style={{ fontSize: "1.05rem", fontWeight: 700 }}>{title}</Modal.Title>
    </Modal.Header>
    <Form onSubmit={onSubmit}>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <button className="plm-btn-ghost" type="button" onClick={onClose} disabled={saving}>
          Cancel
        </button>
        <button className="plm-btn-primary" type="submit" disabled={saving}>
          {saving ? <Spinner animation="border" size="sm" /> : submitLabel}
        </button>
      </Modal.Footer>
    </Form>
  </Modal>
);

export default EntityFormDialog;
